/**
 * Feature toggle to enable automated credit check for OwF applications.
 */
export const OWF_AUTOMATED_CREDIT_CHECK_240702 = 'OWF_AUTOMATED_CREDIT_CHECK_240702';
